import { ComponentCustomProperties, getCurrentInstance } from '@vue/runtime-core';

export const useSharedContext = () => {
	const sharedContext = getCurrentInstance()?.appContext.config.globalProperties;

	return sharedContext as ComponentCustomProperties;
};
